import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import Header from './components/Header.jsx';
import Footer from './components/Footer.jsx';
import Router from './Router';
import ChatWidget from './components/Chat/Chat.jsx';
import ContactSidebar from './components/ContactSlides/ContactSlides.jsx'; // Import du sidebar
import './App.css';
import { HelmetProvider } from 'react-helmet-async';
import ScrollToTop from './components/ScrollToTop.jsx';
const App = () => {
  return (
    <BrowserRouter>
    <ScrollToTop/>
      <HelmetProvider>
        <ContactSidebar />   {/* Ici, sidebar fixe visible partout */}
        <Header />

        <main>
          <ChatWidget />
          <Router />
        </main>
        <Footer />
      </HelmetProvider>
    </BrowserRouter>
  );
};

export default App;
